<script>
export default {
  name: "circular-progress",
  props: {
    lineWidth: {
      type: String,
      default: "4px"
    },
    lineColor: {
      type: String,
      default: "#02cb73"
    },
    defaultLineColor: {
      type: String,
      default: "#ffffff"
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getProgress() {
      let progress = this.progress;
      if (progress > 1) progress = 1;
      // 角度加90，对称轴变换
      let deg = 360 * progress + 90;
      if (deg >= 360) deg -= 360;
      return {
        backgroundImage: `linear-gradient(${
          progress > 0.5
            ? `-90deg, ${this.lineColor}`
            : `90deg, ${this.defaultLineColor}`
        } 50%,transparent 50%),linear-gradient(${deg}deg, ${
          this.lineColor
        } 50%, ${this.defaultLineColor} 50%)`
      };
    }
  }
};
</script>

<template>
  <div class="ht-circular-progress" :style="{padding: lineWidth}">
    <div class="circular-progress" :style="getProgress"></div>
    <div class="circular-progress-slot">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="less">
.ht-circular-progress {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  box-sizing: border-box;
  .circular-progress {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    z-index: -2;
  }
  .circular-progress-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: inherit;
  }
}
</style>
